import classNames from 'classnames';
import React, { FC } from 'react';
import { Typography } from '../Typography';
import styles from './Tag.module.scss';

export type TagProps = {
	variant?: 'green' | 'red' | 'outline' | 'outline-medium' | 'dark' | 'white';
	size?: 'xs' | 'sm';
	flat?: boolean;
	className?: string;
};

export const Tag: FC<TagProps> = ({ variant = 'green', size, flat, className, children }) => {
	return (
		<Typography
			variant="caption"
			className={classNames(styles.tag, 'tag', className, {
				[styles[`tag--${variant}`]]: variant,
				[styles[`tag--${size}`]]: size,
				[styles[`tag--rounded`]]: !flat,
			})}
		>
			{children}
		</Typography>
	);
};
